import { useT } from '@spotify-internal/i18n-core';
import { BreadcrumbItem, Breadcrumbs } from '@components/Breadcrumbs';

interface ArtistBreadcrumbsProps {
  searchQueryParams: string | null;
  fromReleaseId?: string;
  fromTrackId?: string;
}

export const ArtistBreadcrumbs = ({
  searchQueryParams,
  fromReleaseId,
  fromTrackId,
}: ArtistBreadcrumbsProps) => {
  const t = useT();

  const releasePageUrl = `/release/${fromReleaseId}`;
  const trackPageUrl = `/release/${fromReleaseId}/track/${fromTrackId}`;

  return (
    <Breadcrumbs>
      <BreadcrumbItem
        active={false}
        to="/"
        text={t(
          'atlas.breadcrumbs.catalog',
          'Catalog',
          'Text for a breadcrumb link. Refers to "Catalog" in the noun form',
        )}
      />
      {searchQueryParams !== null && (
        <BreadcrumbItem
          active={false}
          to={`/search?${searchQueryParams}`}
          text={t(
            'atlas.breadcrumbs.search',
            'Search',
            'Text for a breadcrumb link. Refers to "Search" in the noun form',
          )}
        />
      )}
      {fromReleaseId && (
        <BreadcrumbItem
          active={false}
          to={releasePageUrl}
          text={t(
            'atlas.breadcrumbs.release',
            'Release',
            'Text for a breadcrumb link. Refers to "Release" in the noun form',
          )}
        />
      )}
      {fromTrackId && fromReleaseId && (
        <BreadcrumbItem
          active={false}
          to={trackPageUrl}
          text={t(
            'atlas.breadcrumbs.track',
            'Track',
            'Text for a breadcrumb link. Refers to "Track" in the noun form',
          )}
        />
      )}
      <BreadcrumbItem
        active
        text={t(
          'atlas.breadcrumbs.artist',
          'Artist',
          'Text for a breadcrumb link. Refers to "Artist" in the noun form',
        )}
        to=""
      />
    </Breadcrumbs>
  );
};
